import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';

import { firstValueFrom } from 'rxjs';

import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';

import { MessageService } from 'primeng/api';
import { notifyAndTrackError } from '../../../common/error';
import { ProcessingComponent } from '../../../components';
import { AppInitService, IInsectaPermissions } from '../../../services/app-init.service';
import { AppInsightsService } from '../../../services/app-insights.service';
import { DictionaryCacheService, IDictionaryEntry } from '../../../services/insecta';

@Component({
  selector: 'app-site-catalog-list',
  standalone: true,
  imports: [ButtonModule, CardModule, CommonModule, FormsModule, RouterModule, ProcessingComponent],

  templateUrl: 'site-catalog-list.component.html'
})
export class SiteCatalogListComponent implements OnInit {
  permissions!: IInsectaPermissions;
  pageVars = {
    isReady: false
  };

  sites: any[] = [];

  constructor(
    private dictionaryCache: DictionaryCacheService,
    private router: Router,
    private appInit: AppInitService,
    private appInsights: AppInsightsService,
    private msgService: MessageService
  ) {}

  ngOnInit() {
    this.pageVars.isReady = false;
    this.permissions = this.appInit.permissions;
    this.sites = [];

    firstValueFrom(this.dictionaryCache.get('site'))
      .then((data: IDictionaryEntry[]) => {
        if (this.permissions.configureSiteCatalogs) {
          this.sites = data.map(
            (site) =>
              <any>{
                title: `${site.text} Catalog`,
                description: `Configure containers, insects, substrates and settings specific to ${site.text}`,
                path: `/admin/sitecatalog/${site.id}`
              }
          );
        }
      })
      .catch((err) => {
        notifyAndTrackError(this.msgService, this.appInsights, err, { component: 'Admin:SiteCatalogList', action: 'Init:Error' });
      })
      .finally(() => {
        this.sites = this.sites.sort((a, b) => (a.title > b.title ? 1 : -1));
        this.pageVars.isReady = true;
      });
  }

  goClick(path: string) {
    this.router.navigateByUrl(path);
  }
}
